<template>
  <v-container>
    <v-list three-line class="notification" min-width="250">
      <template v-for="(note, idx) in notifications">
        <v-list-item
          :class="`${note.readTime === null ? 'unread' : ''}`"
          :key="idx"
          @click="clicked(note)"
        >
          <v-list-item-avatar>
            <v-icon>{{ notificationTypeIcon(note.concernType) }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <div class="top-right">{{ note.sentTime | ago }}</div>
            <div class="content-text py-3">
              <h2>{{ note.subject }}</h2>
              <p class="mb-0">{{notificationType(note.concernType, note?.text)}}</p>
            </div>
            <div v-if="note.readTime === null" class="bottom-right">{{$t("labels.new")}}</div>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import {NotificationMixin} from '@/components/mixins'
import get from 'lodash/get';

// @group Notifications
// NotificationDialog component
export default {
  name: 'NotificationList',
  mixins: [NotificationMixin],
  data: () => ({}),
  created() {},
  computed: {
    ...mapGetters('currentuser', [
      'currentUser',
      'notifications',
      'isAdministrator',
      'isCompanyUser',
      'isCompanyEducationResponsible',
      'isDistanceEducationAdministrator'
    ])
  },
  methods: {
    clicked(note) {
      if (note.type === 'confirmation' && !this.currentUser.companyRoles.some(r => r.Apprentice)) {
        if ( note.concernType === 'Book' )
          this.$router.push({ name: 'PersonBasicEducationTime' });

        if ( get(note, 'concernType', '') === 'QualificationTime' )
          this.$router.push({ 
            name: 'ApprenticeQualifyingTime', 
            params: { id: get(note, 'additionalInfo.belongsToPersonId', -1) } 
          }).catch(() => {});
        
        if(get(note, 'concernType', '') === 'ApprenticeQualificationTime'){
          this.$router.push({ name: 'ApprenticeQualifyingTime' })
        }

      } else {
        this.$router.push({ name: 'EbookEducationStart', params: { id: note.concernId } })
      }
      
      if (note.concernId > 0 && note.additionalInfo && note.additionalInfo.reportId && note.additionalInfo.reportId > 0) {
        //check if clicked link is the same as the route path
        var splitted
        if (this.$route && this.$route.name && note.concernType == 'Book') {
          if (this.$route.name === 'InstructorApprenticesReport') {
            splitted = this.$route.fullPath.split('books/')
          } else if (this.$route.name === 'EbookReportNew') {
            splitted = this.$route.fullPath.split('book/')
          }

          if (splitted && splitted.length > 1) {
            //get book id and the report id from the path
            var pathBookId = splitted[1].substr(0, 1)
            var pathRepId = splitted[1].substr(splitted[1].length - 1)

            if (pathBookId == note.concernId && pathRepId == note.additionalInfo.reportId) {
              this.$emit('closeModal')
              return
            }
          }
        }
      }
      this.$emit('clickNote',note.id)
      if(note && note.additionalInfo){
        this.notificationRoute(note.concernType, note.concernId, note.additionalInfo, {isCompanyUser: this.isCompanyUser(0),isDistanceEducationAdministrator:this.isDistanceEducationAdministrator(note.additionalInfo.companyId)})
        this.$emit('closeModal')
      }

      this.$emit('closeModal')
    }
  }
}
</script>
